import Pair from "../models/Pair";

export const PairMixin = {
    data() {
        return {
            pair: this.initialize()
        }
    },
    methods: {
        initialize() {
            return new Pair({
                symbol: undefined,
                exchange_id: undefined,
                ask_rate: 0,
                bid_rate: 0,
                slippage_percent: 0,
                slippage_amount: 0,
                is_api_enabled: false,
                is_rate_ok: true
            })
        }
    }
}
